import { CoverImageFormPortal } from "../CoverImageFormPortal";
import { useEditHomeCover } from "./useEditHomeCover";

export const HomeCoverForm = () => {
  const {
    coverImage,
    hasCoverImage,
    isAdmin,
    isLoading,
    isSmallScreen,
    onDelete,
    onSubmit,
  } = useEditHomeCover();

  return (
    <CoverImageFormPortal
      coverImage={coverImage}
      enabled={hasCoverImage}
      isLoading={isLoading}
      isMobile={isSmallScreen}
      onDelete={onDelete}
      onSubmit={onSubmit}
      showForm={isAdmin}
    />
  );
};
